import { useNavigate } from 'react-router-dom';
import './go-back-btn.scss';

function GoBackBtn() {
  const history = useNavigate();

  return (
    <button
      className="confirm-btn"
      onClick={() => { history(-1) }}>
      Indietro
    </button>
  );
}

export default GoBackBtn;
